<template>
  <div class="ibox dictMng">
    <div class="ibox-content p-xs">
      <el-tabs v-model="activeName" class="el-tabs-card" @tab-click="handleClick">
        <el-tab-pane v-for="item in tabsArr" :key="item.name" :label="item.label" :name="item.name">
        </el-tab-pane>
      </el-tabs>
      <!-- <RCell
        :title="tabsArr"
        :size="size"
        :tabActive="activeName"
        @on-tab="handleClick"
        ref="tabs"
        type="cellTop"
        class="edit-title cell-top"
      ></RCell> -->
      <div>
        <dict-basical :height="height" v-if="activeName === '1'"></dict-basical>
        <!-- <dict-area :height="height" v-if="activeName === '2'" />
        <dictPoliceStation :height="height" v-if="activeName === '3'" /> -->
      </div>
    </div>
  </div>
</template>
<script>
import dictBasical from './dicts/dictBasical'
import dictArea from './dicts/dictArea'
import dictPoliceStation from './dicts/dictPoliceStation'
import RCell from '@/components/common/RCell'
export default {
  name: 'SystemdictMng',
  components: {
    dictBasical,
    dictArea,
    dictPoliceStation,
    RCell,
  },

  data() {
    return {
      height: null,
      activeName: '1',
      size: 'small',
      tabsArr: [
        {
          label: '基础数据',
          name: '1',
        },
        // {
        //   label: '地区',
        //   name: '2',
        // },
        // {
        //   label: '派出所',
        //   name: '3',
        // },
      ],
    }
  },
  mounted() {
    this.height = $('body').height() - $('#app-main').offset().top - 176
    window.onresize = () => {
      return (() => {
        this.height = $('body').height() - $('#app-main').offset().top - 176
      })()
    }

    let curDictPageTab = localStorage.getItem('curDictPageTab')
    if (curDictPageTab != null) {
      this.activeName = curDictPageTab
    }
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab
      localStorage.setItem('curDictPageTab', tab) // 记录当前字典页面选中的tab项，用途：刷新后恢复选中的tab
      localStorage.removeItem('curUrlPageSize')
      localStorage.removeItem('curUrlPageIndex')
    },
  },
}
</script>
<style lang="less" scoped>
.dictMng :deep(.el-tabs__header.is-top) {
  margin: 0px !important;
}
</style>
